import { ERouterList } from '@internal/router/constants/router-list'

import InnerLayout from '@internal/layouts/inner-layout.vue'

import { auth } from '@internal/router/middleware/auth'

import { EUserRole } from '@shared/api/user-management/resources/user/constants/user-roles'

export const clinician = [
  {
    path: '/clinician/:id/visit-history',
    name: ERouterList.CLINICIAN_VISIT_HISTORY,
    component: () => import('@internal/pages/clinician/_id/visit-history.vue'),
    meta: {
      middleware: [auth],
      middlewareRoleList: [EUserRole.PRACTICE_ADMIN, EUserRole.PRACTICE_CLINICIAN],
      layout: InnerLayout,
    },
  },
  {
    path: '/clinician/:id/filter',
    name: ERouterList.CLINICIAN_VISIT_HISTORY_FILTER,
    component: () => import('@internal/pages/clinician/_id/filter.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
]

export default clinician
